<!-- Asset Error Modal -->
<div id="assetErrorModal" class="modal fade assetErrorModalClass" role="dialog" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" *ngIf="isShown">
            <div class="modal-header">
                <p class="modal-title">{{ 'FOC.DESKTOP.APP_ASSET_ERROR_MODAL.MODAL_TITLE' | translate}}</p>
                <button id="assetErrorModalCloseButton" type="button" class="close" data-dismiss="modal"
                    [attr.qid]="assetError-1" title="{{ 'FOC._COMMON_ACROSS_PAGES.NOTES.CLOSE_NOTES' | translate }}">
                    <i aria-hidden="true" class="nemo-font nemo-cross"></i></button>
            </div>
            <div class="modal-body">
                <p class="modal-message">{{ 'FOC.DESKTOP.APP_ASSET_ERROR_MODAL.MODAL_BODY_CONTENT_1' | translate}}</p>
                <p class="modal-message" *ngIf="!isOnline">
                    {{'FOC.DESKTOP.APP_ASSET_ERROR_MODAL.MODAL_BODY_CONTENT_2_OFFLINE' | translate}}
                </p>
                <p class="modal-message" *ngIf="isOnline">
                    {{'FOC.DESKTOP.APP_ASSET_ERROR_MODAL.MODAL_BODY_CONTENT_3_ONLINE' | translate}}
                </p>
            </div>
            <div class="modal-footer">
                <button id="assetErrorModalRedirectButton1" type="button"
                    class="btn btn-default btn-main-1 assetErrorModalRedirectButton" data-dismiss="modal"
                    [attr.qid]="assetError-2">
                    {{'FOC.DESKTOP.APP_ASSET_ERROR_MODAL.MODAL_BUTTON_1_OFFLINE' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>